/* 🤖 this file was generated by svg-to-ts */
export const matIconNavigateBefore: {
  name: 'navigate-before';
  data: string;
} = {
  name: 'navigate-before',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.61 7.41 14.2 6l-6 6 6 6 1.41-1.41L11.03 12l4.58-4.59z"/></svg>`
};
